import { render, staticRenderFns } from "./tabGatheringTrailerBase.vue?vue&type=template&id=d65f9628&scoped=true&"
import script from "./tabGatheringTrailerBase.vue?vue&type=script&lang=js&"
export * from "./tabGatheringTrailerBase.vue?vue&type=script&lang=js&"
import style0 from "./tabGatheringTrailerBase.vue?vue&type=style&index=0&id=d65f9628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65f9628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65f9628')) {
      api.createRecord('d65f9628', component.options)
    } else {
      api.reload('d65f9628', component.options)
    }
    module.hot.accept("./tabGatheringTrailerBase.vue?vue&type=template&id=d65f9628&scoped=true&", function () {
      api.rerender('d65f9628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBase.vue"
export default component.exports